import type * as AddBasketOffer from '@ori-events/add-basket-offer';
import type { PositionData } from '@ori/analytics-data';

import { isAddBasketOfferPurchaseEvent } from '../guards/addBasketOfferRequest';
import { addBasketOffer } from '../helpers';
import { RequestUrl } from '../models';

type Data = AddBasketOffer.Data & PositionData;
type PurchaseData = AddBasketOffer.AddBasketOfferPurchaseData & PositionData;

export default async (event: AddBasketOffer.Event) => {
  if (isAddBasketOfferPurchaseEvent(event)) {
    const {
      detail: { items, offerId: choiceId, placement: currentPlacement },
    } = event as CustomEvent<PurchaseData>;

    return addBasketOffer(RequestUrl.PurchaseBasketOffer, {
      choiceId,
      items,
      placement: currentPlacement,
    });
  }

  const {
    detail: { offerId, placement },
  } = event as CustomEvent<Data>;

  return addBasketOffer(RequestUrl.AddBasketOffer, {
    offerId,
    placement,
  });
};
